const ERRORS = {
    404: "Такой папки не существует",
    403: "У вас нет доступа к этой папке",
};

export const getDirectoryError = code => ERRORS[code] || "Не удалось загрузить задачи";
